import { useAtom } from "jotai";
import { createFormAtom } from "../atoms/createFormAtom";
import { useSubmitForm } from "../hooks/useSubmitForm";
import Loader from "./Loader";
import { BsCheck2Circle } from "react-icons/bs";
import usePaperlessNavigate from "../hooks/usePaperlessNavigate";
import NetworkError from "./NetworkError";
import { useEffect } from "react";

const FormLayout = ({ children }) => {
  const [formAtomValue, setFormAtom] = useAtom(createFormAtom);
  const { data, isLoading, error, isError, mutate: submit, isSuccess } = useSubmitForm(formAtomValue);
  const { paperlessNavigate } = usePaperlessNavigate();

  // Ensure pNumber is in atom (from localStorage) as early as possible
  useEffect(() => {
    const stored = localStorage.getItem("selectedBranchId");
    if (stored && Number(stored) > 0 && formAtomValue?.pNumber !== Number(stored)) {
      setFormAtom((prev) => ({ ...prev, pNumber: Number(stored) }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // run once

  const handleSubmit = (e) => {
    e.preventDefault();

    // Double-check pNumber just before submit
    const stored = localStorage.getItem("selectedBranchId");
    if (stored && Number(stored) > 0 && formAtomValue?.pNumber !== Number(stored)) {
      setFormAtom((prev) => ({ ...prev, pNumber: stored }));
    }

    // Now submit uses the latest atom value (hook depends on atom value and re-renders)
    submit();
  };

  const handleNavigation = () => {
    setFormAtom({
      categoryId: 0,
      formTypeId: "",
      formValues: [],
      pNumber: undefined, // optional reset
    });
    paperlessNavigate({
      destination: `/categories`,
      payload: "",
    });
  };

  if (isError) {
    return <NetworkError error={error} />;
  }

  return (
    <form onSubmit={handleSubmit} className={""}>
      {children}
      <button className={"text-white p-1.5 w-full bg-[#0A0D36] mt-6 shadow-lg text-lg"} disabled={isLoading}>
        Submit
      </button>
      {isLoading && <Loader className={"fixed inset-0"} />}
      {isSuccess && (
        <div className={"fixed inset-0 bg-black/20 flex items-center justify-center"}>
          <div className={"bg-white p-5 rounded flex flex-col items-center justify-center"}>
            <BsCheck2Circle className={"text-green-600 h-16 w-16"} />
            <p className={"py-1.5 text-green-700"}> Your request has been submitted successfully</p>
            <p className={"py-1 text-gray-600"}>
              Ticket No.:
              <span className={"px-2 font-bold text-gray-800 text-lg"}>{data.data.result?.ticket}</span>
            </p>
            <p className={"py-1 text-gray-600"}>
              Proceed to <span className={"font-bold text-gray-800 text-lg"}>{data.data.result?.desk} </span> to
              complete your transaction.
            </p>
            <button
              type={"button"}
              onClick={handleNavigation}
              className={"py-1.5 bg-[#0A0D36] text-white shadow w-full mt-4 rounded"}
            >
              Ok
            </button>
          </div>
        </div>
      )}
    </form>
  );
};

export default FormLayout;
